export default {"src":"/polygon/_next/static/media/fund_9.6fdd1019.svg","height":80,"width":231};